import React, { Component } from "react";

class ChildStory extends Component {
  constructor(props) {
    super(props);
  }

  renderImage(){
    return (
        <img className={`child__thumbnail child-story__thumbnail`} src={this.props.childImage} />
    );
  }

  render() {
    const childStory = this.props.story;
    const imageThumb = (this.props.device === "mobile" || this.props.device === "tablet")? this.renderImage() :  null;

    return (
      <div className={`child-story child-detail__item`}>
        {imageThumb}
        <div className={`child-story__wrapper`}>
        {childStory.map((item, index) => {
          return (
            <p key={index} className={`child-story__content-${index}`}>
              {item}
            </p>
          );
        })}
        </div>
      </div>
    );
  }
}


export default ChildStory;
